import React from 'react'
import MCBanner from '@mc/banner'
import { Trans, useTranslation } from '@mc/i18n'
import { useExperiment } from '../../hooks/useExperiment'
import { INTRO_PRICING_I18N_NAMESPACE } from '../../i18n'

export const Banner = () => {
  const { t } = useTranslation(INTRO_PRICING_I18N_NAMESPACE)
  const { isVariant, bucket } = useExperiment()
  const mode = bucket === 'variant_1' ? 'premium' : 'upgrade'

  if (!isVariant || bucket === 'variant_4') {
    return null
  }

  return (
    <MCBanner theme='light' aria-label={t('banner.a11y')}>
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-center mc-px-4 mc-py-3'>
        <h2
          className='d-md-none mc-mb-1 mc-text-h2 mc-text--brand mc-text--uppercase'
          style={{ fontSize: '28px' }}
        >
          <Trans
            i18nKey={`banner.title.${mode}`}
            ns={INTRO_PRICING_I18N_NAMESPACE}
            components={{
              highlight: <span className='mc-text-color--primary' />,
            }}
          />
        </h2>
        <h2 className='d-none d-md-block mc-mr-4 mc-text-h3 mc-text--brand mc-text--uppercase'>
          <Trans
            i18nKey={`banner.title.${mode}`}
            ns={INTRO_PRICING_I18N_NAMESPACE}
            components={{
              highlight: <span className='mc-text-color--primary' />,
            }}
          />
        </h2>

        <p className='mc-text-small'>{t(`banner.subtitle.${mode}`)}</p>
      </div>
    </MCBanner>
  )
}
